// Legacy company query redirects intentionally disabled.
//
// Company / official-site searches stay on /search?q=... and are rendered
// through the live backend official_site payload using CompanySiteResult.ts.
// Do not repopulate this map with /companies/... routes.
export const companySearchMap: Record<string, string> = {};
